import React from 'react';

const Brand = ({ size = 28 }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
    <img
      src="/logo192.png"
      alt="Ciphercurve"
      style={{ height: size, width: 'auto', display: 'block' }}
    />
    <span className="wordmark">
      cipher<span className="slash">//</span>curve
    </span>
  </span>
);

export default Brand;
